export default __webpack_public_path__ + "static/media/greenlipped16000_120s_900.c48a113a.png";